import { createAction, props } from '@ngrx/store';
import { PlantListInterface } from 'src/app/pages/record/interfaces';

export const loadPlantListUserGuid = createAction('[PlantListUserGuid] Load');
export const loadPlantListUserGuidSuccess = createAction(
  '[PlantListUserGuid] Load Success',
  props<{ key: string; plants: PlantListInterface[] }>(),
);
export const loadPlantListUserGuidFailure = createAction(
  '[PlantListUserGuid] Load Failure',
  props<{ error: string; key: string }>(),
);
export const resetPlantListUserGuid = createAction('[PlantListUserGuid] Reset');
export const refreshPlantListUserGuid = createAction('[PlantListUserGuid] Refresh');
